import { matchSorter } from 'match-sorter';
import tmsApi from './../api/tmsApi';

export default {
  namespaced: true,
  state: {
    dataState: {
      companies: 'IDLE',
    },
    dataPromise: null,
    companies: [],
    query: {
      search: '',
      loadEmptyQuery: false,
      type: null,
      having: '',
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.companies.splice(0);
    },
    REPLACE_DATA(state, companies) {
      state.companies.splice(0, state.companies.length, ...companies);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    SET_QUERY_TYPE(state, type) {
      if (type !== state.query.type) {
        state.dataPromise = null;
      }
      state.query.type = type;
    },
    SET_QUERY_SEARCH(state, search) {
      if (search !== state.query.search) {
        state.dataPromise = null;
      }
      state.query.search = search;
    },
    SET_QUERY_HAVING(state, having) {
      if (having !== state.query.having) {
        state.dataPromise = null;
      }
      state.query.having = having;
    },
    SET_DATA_STATE(state, dataState) {
      state.dataState.companies = dataState;
    },
    LOAD_EMPTY_QUERY(state, load) {
      state.query.loadEmptyQuery = load;
    },
  },
  getters: {
    companies(state) {
      return state.companies;
    },
    isLoading(state) {
      return state.dataState.companies === 'LOADING';
    },
  },
  actions: {
    FREE_SEARCH_DATA({ rootState, state, commit }, querySearch) {
      commit('SET_QUERY_SEARCH', querySearch);

      if (state.dataPromise !== null) {
        return state.dataPromise;
      }
      const api = tmsApi.buildRetry(rootState.token);
      const { value } = querySearch;
      const val = value.trim();
      if (!state.query.loadEmptyQuery && val === '') {
        return Promise.resolve();
      }
      let type = '';
      if (state.query.type !== null && state.query.type !== '') {
        type = `, type: ${state.query.type}`;
      }
      let having = '';
      if (state.query.having !== '') {
        having = `, having: "${state.query.having}"`;
      }
      const query = `{
        companies: find_companies(query: "${val}", active: true ${type} ${having}) {
          id
          name
          type
        }
      }`;

      commit('SET_DATA_STATE', 'LOADING');
      state.dataPromise = api(query, 'search_company').then(({ data }) => {
        const companies = matchSorter(data.companies, val, { keys: ['name'] });
        commit('REPLACE_DATA', companies);
      }).catch((error) => {
        commit('ADD_ERROR', error.message);
      }).finally(() => {
        commit('SET_DATA_STATE', 'IDLE');
      });
      return state.dataPromise;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/company_select.js